/* Duskhaven motion (2026-10-07). See assets/dh-motion.css for the recipe.
   Plain script (no import()), safe to load with defer. If anything here fails or never runs, nothing stays hidden:
   the CSS only hides after this script adds html.dh-mo, the inline script in dh-head removes html.dh-mo-pre after 2s,
   and a 2s timer below reveals anything still waiting.
   2026-10-14 (Todd): product cards no longer rise or stagger in. They are simply there; only their photo fades in softly
   once loaded. The rise-in is kept for headlines, section heads and room tiles. */
(function () {
  'use strict';
  var d = document;
  var root = d.documentElement;
  if (window.__dhMotion) return;
  window.__dhMotion = true;

  function done() { root.classList.remove('dh-mo-pre'); }

  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  if (reduce || !('IntersectionObserver' in window)) { done(); return; }

  /* ---- 1. Headline words (hero eyebrow text, collection hero title) ---- */
  var SPLIT = '.dhc-title, .dhh-eyebrow-text, [data-dh-words]';
  function splitWords(el) {
    if (el.getAttribute('data-dh-split')) return;
    el.setAttribute('data-dh-split', '1');
    var w = d.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = w.nextNode())) { if (n.nodeValue && n.nodeValue.trim()) nodes.push(n); }
    nodes.forEach(function (t) {
      var frag = d.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(d.createTextNode(p)); return; }
        var s = d.createElement('span');
        s.className = 'dh-w';
        s.textContent = p;
        s.style.setProperty('--dh-wd', (120 + Math.random() * 350).toFixed(0) + 'ms');
        frag.appendChild(s);
      });
      t.parentNode.replaceChild(frag, t);
    });
  }
  try { d.querySelectorAll(SPLIT).forEach(splitWords); } catch (e) {}
  done();

  /* ---- 2. Scroll reveal for room tiles and section heads (not product cards) ---- */
  var REVEAL = '.dhr-tile, .dh-top, .dhr-head, .dh-featured-head';
  var STEP = 90;
  var MAXDELAY = 720;
  var ioSeen = false;
  var waiting = [];

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 800) && r.right > 0 && r.left < (window.innerWidth || 1200);
  }
  function show(el, delay) {
    el.style.setProperty('--dh-d', delay + 'ms');
    el.classList.add('dh-in');
    io.unobserve(el);
    var i = waiting.indexOf(el);
    if (i > -1) waiting.splice(i, 1);
  }

  var io = new IntersectionObserver(function (entries) {
    ioSeen = true;
    var hit = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
    hit.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    hit.forEach(function (el, i) { show(el, Math.min(i * STEP, MAXDELAY)); });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  /* ---- 3. Product cards: no movement; the photo fades in (0.35s) once it has loaded ---- */
  var CARD_IMG = '.dh-card img, .dhc-cat-item img';
  try {
    var st = d.createElement('style');
    st.textContent = '.dh-img-wait{opacity:0 !important}.dh-img-in{animation:dh-imgin .35s ease-out backwards}@keyframes dh-imgin{from{opacity:0}}';
    d.head.appendChild(st);
  } catch (e) {}
  function prepImgs() {
    var imgs = [];
    try { imgs = [].slice.call(d.querySelectorAll(CARD_IMG)); } catch (e) {}
    imgs.forEach(function (im) {
      if (im.__dhImg) return;
      im.__dhImg = true;
      if (im.complete) return;
      im.classList.add('dh-img-wait');
      var ok = function () {
        im.classList.remove('dh-img-wait');
        im.classList.add('dh-img-in');
        im.removeEventListener('load', ok);
        im.removeEventListener('error', ok);
      };
      im.addEventListener('load', ok);
      im.addEventListener('error', ok);
      setTimeout(function () { im.classList.remove('dh-img-wait'); }, 2500);
    });
  }

  function scan(initial) {
    var found = [];
    try { found = [].slice.call(d.querySelectorAll(REVEAL)); } catch (e) {}
    var fresh = [];
    found.forEach(function (el) {
      if (el.hasAttribute('data-dh-rv')) return;
      if (el.parentElement && el.parentElement.closest('[data-dh-rv]')) return;
      el.setAttribute('data-dh-rv', '');
      /* On the first pass, anything already on screen stays as it is, so the page paints at full speed. */
      if (initial && inView(el)) { el.classList.add('dh-in'); el.style.setProperty('--dh-d', '0ms'); el.style.animation = 'none'; return; }
      fresh.push(el);
    });
    if (fresh.length) {
      root.classList.add('dh-mo');
      fresh.forEach(function (el) { waiting.push(el); io.observe(el); });
    }
    prepImgs();
  }
  scan(true);

  /* Cards that arrive later (filters, load more, quick view lists) get the same treatment. */
  var timer = 0;
  try {
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { scan(false); }, 120);
    }).observe(d.body, { childList: true, subtree: true });
  } catch (e) {}

  /* Safety: if the observer never reports, or something is still hidden while on screen, reveal it. */
  setTimeout(function () {
    if (!ioSeen) { root.classList.remove('dh-mo'); return; }
    waiting.slice().forEach(function (el) { if (inView(el)) show(el, 0); });
  }, 2000);
})();
